import CrudManager from "@/components/admin/CrudManager";

export default function ReviewsAdmin() {
  return (
    <CrudManager
      title="Reviews" subtitle="Manage customer reviews (only add genuine reviews)." testid="admin-reviews"
      endpoint={{ public: "/reviews", admin: "/admin/reviews" }} queryKey="reviews"
      columns={[
        { key: "name", label: "Name" },
        { key: "rating", label: "Rating", render: (r) => `${r.rating || 5} ★` },
        { key: "text", label: "Review" },
        { key: "published", label: "Published" },
      ]}
      fields={[
        { key: "name", label: "Customer Name" },
        { key: "location", label: "Location (optional)" },
        { key: "rating", label: "Rating (1-5)", type: "number" },
        { key: "text", label: "Review Text", type: "textarea", rows: 3 },
        { key: "published", label: "Published", type: "checkbox", checkboxLabel: "Show on website" },
        { key: "order", label: "Sort Order", type: "number" },
      ]}
    />
  );
}
